<template>
 <div class="container">
  <ToastPrime />
    <div class="table-display2">
       <div class="cell-display div2">
         <div class="card">
           <div class="formgrid grid">
            <div class="field col-12 md:col-2 text-left"> 
              <label for="shipName">{{ $t("shipName") }}</label>
              <p
                id="shipName"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.name }}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="shipIMO">{{ $t("imoNumber") }}</label>
              <p
                id="shipIMO"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.imo }}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="shipType">{{ $t("shipType") }}</label>
              <p
                id="shipType"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.shipType.name }}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="shipGT">{{ $t("grossTonnage") }} - <strong>GT</strong> (t)</label>
              <p
                id="shipGT"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.gt}}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="shipDWT">{{ $t("capacityDeadWeight") }} - <strong>DWT</strong> (t)</label>
              <p
                id="shipDWT"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.dwt }}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="shipTotalDistance">{{ $t("totalDistance") }} (mn)</label>
              <p
                id="shipTotalDistance"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.totalDistance}}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="iceClass">{{ $t("iceClass") }}</label>
              <p
                id="iceClass"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.iceClassType.name}}</strong></p>
            </div>
          </div>

          <div class="formgrid grid">
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-4">
              <FuelConsumptionTable :fuelArray = "fuelConsumptionArray"></FuelConsumptionTable>
            </div>
            <div class="field col-12 md:col-1"></div>
            <div class="field col-12 md:col-3">
              <div id ="oldCIIBox">
                  <p class="oldPrewittenCIILabel"><strong>{{ $t("oldRewrittenCII") }} (gCO<sub>2</sub>/t*mn):</strong></p>
                  <div style="display: flex;  padding-top: 4%;">
                    <div>
                      <li v-for="(year, index) in this.firstHalfOldCIIList" :key="index" style="width:200px; padding-bottom: 10px;">
                        &ensp; {{ year.year }} &nbsp; <p class="CII_value">  {{year.value}} </p> &emsp;
                      </li>
                    </div>
                    <div>
                      <li v-for="(year, index) in this.secondHalfOldCIIList" :key="index" style="width:200px; padding-bottom: 10px;">
                        &ensp; {{ year.year }} &nbsp; <p class="CII_value">  {{year.value}} </p> &emsp;
                      </li>
                    </div>
                  </div>
              </div>
            </div>
          </div>

          <!-- Empezamos con los inputs-->
          <div class="formgrid grid">
            <div class="field col-12 md:col-12 p-2"></div>
             <!-- Aquí mostramos la caja con algunos de los inputs-->
            <div class="input-box">

              <div style="display: flex;">
                <div v-if="this.ship.shipType.code == 'TNK'" class="field col-12 md:col-6 text-left">
                  <label for="questionIsChemicalTankShip">{{ $t("questionIsChemicalTankShip") }}</label>
                  <SelectButton
                    id="questionIsChemicalTankShip"
                    name="shipChemicalTanker"
                    v-model="shipChemicalTanker"
                    :options="options"
                  />
                </div>
                <div v-if="this.shipChemicalTanker == 'Yes'" class="field col-12 md:col-8 text-left">
                  <label for="shipVTanks"
                    >{{ $t("vTanks") }} - <strong>V<sub>tanks</sub></strong> (m&sup3;)</label
                  >
                  <input
                    id="shipVTanks"
                    v-model="ship.vTanks"
                    type="number"
                    class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  />
                </div>
              </div>
              
              <div class="field col-12 md:col-12 p-2"></div>

              <div style="display: flex;">
                <div v-if="this.ship.shipType.code == 'BLC'" class="field col-12 md:col-6 text-left">
                  <label for="questionLightTransport">{{ $t("questionLightTransport") }}</label>
                  <SelectButton
                    id="questionLightTransport"
                    name="shipLightTransport"
                    v-model="shipLightTransport"
                    :options="options"
                  />
                </div>
              </div>

              <div class="field col-12 md:col-12 p-2"></div>

              <div class="display-flex">
                <div v-if="ship.shipType.code =='TNK'" class="field col-12 md:col-6 text-left">
                  <p for="shipTankerElement">{{ $t("questionShipTanker") }}</p>
                  <DropdownPrime
                    id="shipTankerElement"
                    v-model="shipTankerTypeSelected"
                    :options="transformedShipTankerOptions"
                    optionLabel="name"
                    class="field col-12 md:col-12"
                  />
                </div>
                <div class="field col-12 md:col-6 text-left">
                  <label for="questionStructuralImprovements">{{ $t("questionStructuralImprovements") }}</label>
                  <SelectButton
                    id="questionStructuralImprovements"
                    name="shipStructuralImprovements"
                    v-model="shipStructuralImprovements"
                    :options="options"
                  />
                </div>
                
              </div>
              <div class="field col-12 md:col-12 p-2"></div>
              
              <!--Párrafo de las preguntas de mejoras estructurales específicas-->
              <div v-if="shipStructuralImprovements == 'Yes'" class="field col-3 md:col-6 text-left">
                  <div style="display: flex;">
                    <div class="field col-2 md:col-6 text-left">
                      <label for="lastname6">{{ $t("lwtReferenceDesign") }} - <strong>LWT<sub>referencedesign</sub></strong> (t)</label>
                      <input
                        type="number"
                        v-model="ship.lwtReferenceDesign"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                      />
                    </div>
                    <div class="field col-2 md:col-6 text-left">
                      <label for="lastname6">{{ $t("lwtEnhancedDesign") }} - <strong>LWT<sub>enhanceddesign</sub></strong> (t)</label>
                      <input
                        type="number"
                        v-model="ship.lwtEnhancedDesign"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                      />
                    </div>
                  </div>
                </div>

            </div>
            <div class="field col-12 md:col-12 p-2"></div>
            <!-- Aquí mostramos la otra caja con otros de los inputs-->
            <div class="input-box-two">
              <!-- Ponemos la tabla para poner los inputs de los FC para cada tipo de combustible-->
              <div class="display-flex">
                <!--Primera columna del inputbox-->
                <div>
                  <table class="styled-table">
                    <thead>
                      <tr>
                        <th scope="col">{{ $t("fuelType") }}</th>
                        <th scope="col">FC<sub>voyage</sub> (g)</th>
                        <th scope="col">FC<sub>boiler</sub> (g)</th>
                        <th scope="col">FC<sub>others</sub> (g)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in this.arrayFuelVariables" :key="index">
                      <td>
                          {{ item.fuel.fuel.name }}
                      </td>
                      <td>
                        <input class="input-style" v-model="item.FCvoyage" type="number" />
                      </td>
                      <td>
                        <input class="input-style" v-model="item.FCboiler" type="number" />
                      </td>
                      <td>
                        <input class="input-style" v-model="item.FCothers" type="number" />
                      </td>
                      </tr>
                    </tbody>
                  </table>              
                </div>

                <div class="field col-12 md:col-1 p-2"></div>
                <!-- El resto de inputs que son normales (no tabla)-->
                <div class="field col-12 md:col-7 text-left">
                  <label for="travelDistance">{{ $t("travelDistance") }} - <strong>D<sub>x</sub></strong> (m)</label>
                  <input
                    v-model="travelDistance"
                    type="number"
                    class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  />
                </div>
              </div>

              <div class="field col-13 md:col-13 p-2"></div>

              <div style="display: flex;">
                <p for="fuelOptions" style="padding-top: 20px; padding-right: 10px;"><strong>{{ $t("fuelType") }}:</strong></p>
                <DropdownPrime
                  id="fuelOptions"
                  v-model="fuelTypeSelected"
                  :options="transformedFuelOptions"
                  optionLabel="name"
                  class="field col-1 md:col-2"
                />

                <p style="padding-top: 20px; padding-left: 10px;"> <strong>{{ $t("modifWarning") }}:</strong> {{ $t("warningFCelectrical") }}</p>
              </div>
              <div class="input-fuel-box">
                <!--Haremos un for de los items (v-for="(fuel, index) in this.arrayFuelVariables" :key="index"), pero con párrafos,
                y con un v-if sólo se muestren si el nombre el combustible seleccionado es el mismo-->
                <div v-for="(item, index) in filteredFuelVariables" :key="index">
                  <div style="display: flex;">
                    <div class="field col-2 md:col-4">
                      <div style="text-align: left;">
                        <p for="fcElec">{{ $t("selectionFCelectrical") }} - <strong>FC<sub>electrical</sub>:</strong></p>
                        <DropdownPrime
                          id="fcElec"
                          v-model="item.typeFCelec"
                          :options="transformedFCElectricalOptions"
                          optionLabel="name"
                        />
                      </div>

                      <div v-if="item.typeFCelec?.name === 'Contenedores refrigerados (reefer)'" 
                      style="padding-top: 10px; text-align: left; padding-left: 20px;">
                        <label for="questionCanMonitorElecConsumption">¿Puede vigilar el consumo eléctrico?</label>
                        <SelectButton style="padding-top: 5px;"
                          id="questionCanMonitorElecConsumption"
                          name="canMonitorElecConsumption"
                          v-model="item.canMonitorElecConsumption"
                          :options="options"
                        />
                      </div>
                    </div>

                    <div class="field col-2 md:col-4">
                      <div v-if="item.typeFCelec?.name === 'Contenedores refrigerados (reefer)'" style="padding-left: 25px">
                        <ul>
                          <li style="text-align: left;">{{ $t("secondInputBox_msg1") }}:</li>
                          <ul>
                            <li v-if="item.canMonitorElecConsumption === 'Yes'" style="text-align: left;">
                              {{ $t("secondInputBox_msg1_1") }}:
                              <div style="padding-top: 10px;">
                                <label for="reefer">Reefer (kWh)</label>
                                <input
                                  v-model="item.reefer"
                                  type="number"
                                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                                />
                              </div>
                            </li>
                            <li v-if="item.canMonitorElecConsumption === 'No'" style="text-align: left; padding-top: 10px;">
                              {{ $t("secondInputBox_msg1_2") }}:
                            
                              <div class="display-flex">
                                <div>
                                  <div style="padding-top: 10px;">
                                    <label for="daysSea">{{ $t("daysSea") }}:</label>
                                    <input
                                      v-model="item.daysSea"
                                      type="number"
                                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                                    />
                                  </div>
                                  <div style="padding-top: 10px;">
                                    <label for="daysPort">{{ $t("daysPort") }}:</label>
                                    <input
                                      v-model="item.daysPort"
                                      type="number"
                                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                                    />
                                  </div>
                                  <div style="padding-top: 10px;">
                                    <label for="numContainers">{{ $t("numContainers") }}:</label>
                                    <input
                                      v-model="item.numContainers"
                                      type="number"
                                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                                    />
                                  </div>                           
                                </div>

                                <div>
                                  <div style="padding-top: 10px;">
                                    <label for="nocArrival">Noc Arrival</label>
                                    <input
                                      v-model="item.nocArrival"
                                      type="number"
                                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                                    />
                                  </div>
                                  <div style="padding-top: 10px;">
                                    <label for="nocDeparture">Noc Departure</label>
                                    <input
                                      v-model="item.nocDeparture"
                                      type="number"
                                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                                    />
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </ul>
                      </div>
                      
                      <div v-if="item.typeFCelec?.name === 'Sistemas de refrigeración en buques gaseros y GNL (cooling)'" style="padding-left: 25px">
                        <ul>
                          <li style="text-align: left; padding-top: 10px;">
                            {{ $t("secondInputBox_msg2") }}:
                            <div style="padding-top: 10px;">
                              <label for="cooling">Cooling (kWh):</label>
                              <input
                                v-model="item.cooling"
                                type="number"
                                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                              />
                            </div>
                          </li>
                        </ul>
                      </div>

                      

                      <div v-if="item.typeFCelec?.name === 'Bombas de descarga eléctricas (discharge)'"  style="padding-left: 25px">
                        <ul>
                          <li style="text-align: left; padding-top: 10px;">
                            {{ $t("secondInputBox_msg3") }}:
                            <div style="padding-top: 10px;">
                              <label for="discharge">Discharge (kWh):</label>
                              <input
                                v-model="item.discharge"
                                type="number"
                                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                              />
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="field col-2 md:col-4">
                      <div style="text-align: left;">
                        <p for="sfocOption">{{ $t("labelSFOC") }} - <strong>SFOC</strong> (g/kWh) </p>
                        <DropdownPrime
                            id="sfocOption"
                            v-model="item.selectedSFOC"
                            :options="transformedSfocValuesOptions"
                            optionLabel="name"
                          />
                      </div>
                      <!--SFOC = 200 o SFOC = 175-->
                      <div v-if="item.selectedSFOC?.name == '200' || item.selectedSFOC?.name == '175'" style="padding-top: 20px;text-align: left;">
                        <label for="sfocFijo">SFOC (g/kWh): </label>
                        <p id="sfocFijo"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        {{ item.selectedSFOC.name }}</p>
                      </div>
                      <!--SFOC libre-->
                      <div v-if="item.selectedSFOC?.name == 'Personalized'" style="padding-top: 20px;text-align: left;">
                        <label for="discharge">SFOC (g/kWh): </label>
                        <input
                          v-model="item.personalizedSFOC"
                          type="number"
                          class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                        />
                      </div>
                    </div>

                  </div> 
                  <div class="field col-12 md:col-12 p-2"></div>
                  <!--FCs-->
                  <div v-if="shipTankerTypeSelected.name =='STS (Ship to Ship)'" style="height: 100px; width: 610px; text-align: left">
                    <label for="fcs">{{ $t("labelFCs") }} - <strong>FC<sub>s</sub></strong> (gr):</label>
                    <input
                      v-model="item.FCs"
                      type="number"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance- outline-none focus:border-primary w-full"
                    />
                  </div>

                </div>
              </div>
            </div>

            <div class="field col-12 md:col-12 p-2"></div>
            <!-- Aquí mostramos la caja con los outputs del CII-->
            <div class="output-box">
              <div style="display: flex;">
                <div style="padding-right: 30px;">
                    <p style="text-align: left;"><strong>{{ $t("anualPrewrittenCII") }} (gCO<sub>2</sub>/t*mn):</strong></p>
                    <div style="display: flex;  padding-top: 4%;">
                      <div>
                        <li v-for="(year, index) in this.firstHalfCIIList" :key="index" style="width:200px; padding-bottom: 10px;">
                          &ensp; {{ year.year }} &nbsp; <p class="CII_value">  {{year.value}} </p> &emsp;
                        </li>
                      </div>
                      <div>
                        <li v-for="(year, index) in this.secondHalfCIIList" :key="index" style="width:200px; padding-bottom: 10px;">
                          &ensp; {{ year.year }} &nbsp; <p class="CII_value">  {{year.value}} </p> &emsp;
                        </li>
                      </div>
                      <div>
                        <li v-for="(year, index) in this.thirdHalfCIIList" :key="index" style="width:200px; padding-bottom: 10px;">
                          &ensp; {{ year.year }} &nbsp; <p class="CII_value">  {{year.value}} </p> &emsp;
                        </li>
                      </div>
                    </div>
                </div>
              </div>
        
              <div class="field col-12 md:col-12 p-2"></div>

              <!-- Botones -->
              <div style="padding-left: 60%;">
                <ButtonPrime @click="calcAnualCII()" class="button">{{ $t("buttonPrewrittenCII") }}</ButtonPrime> &ensp;
                <ButtonPrime @click="calcAttainedCII()" class="button">{{ $t("buttonAttainedCII") }}</ButtonPrime>
              </div>
            </div>

          </div>
        
        </div>

        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
        <!--@click="save()"-->
        <div style="padding-left: 60%;">
          <ButtonPrime @click="save()" id="add-button" class="button">{{ $t("save") }}</ButtonPrime>
          &ensp; &ensp; &ensp; &ensp;
          <ButtonPrime @click="cancel()" id="add-button" class="button">{{ $t("cancel") }}</ButtonPrime>
        </div>

        <!--Párrafos para separar-->
        <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
         </div>
    </div>  

    <!--Modal con los resultados-->
    <DialogPrime
      :header="$t('headerCarbonForm')"
      v-model:visible="modalVisible"
      :breakpoints="{ '960px': '50vw', '640px': '50vw' }"
      :style="{ width: '40vw' }">

      <div>

        <div style="display: flex;">
          <div v-for="(item, index) in this.firstLineLetterValues" :key="index">
            <div class="letter-cii-value">
              {{ item.year }}
            </div>
            <div class="letter-cii-value">
              {{ item.value }}
            </div>
            <div :id="item.color" class="letter-cii-value">
              {{ item.letter }}
            </div>
          </div>
        </div>
        

        <div class="field col-12 md:col-12 p-2"></div>

        <div style="display: flex;">
          <div v-for="(item, index) in this.secondLineLetterValues" :key="index">
            <div class="letter-cii-value">
              {{ item.year }}
            </div>
            <div class="letter-cii-value">
              {{ item.value }}
            </div>
            <div :id="item.color" class="letter-cii-value">
              {{ item.letter }}
            </div>
          </div>
        </div>
       

        <div class="field col-12 md:col-12 p-2"></div>
        
        <div style="display: flex;">
          <div v-for="(item, index) in this.thirdLineLetterValues" :key="index">
            <div class="letter-cii-value">
              {{ item.year }}
            </div>
            <div class="letter-cii-value">
              {{ item.value }}
            </div>
            <div :id="item.color" class="letter-cii-value">
              {{ item.letter }}
            </div>
          </div>
        </div>
      
      </div>
      
    </DialogPrime>
 </div>
</template>

<script>
import router from "@/router/index";
import utils from "@/utils/configuration/config.js";
import store from "@/store/index";
import { ToastSeverity } from "primevue/api";
import ShipService from "@/services/ShipService";
import ParametricTableService from "@/services/ParametricTableService";
import NeobuqCarbonService from "@/services/Neobuq/NeobuqCarbonService";
import FuelConsumptionTable from "./FuelConsumptionTable.vue";

export default {

  components: {
    FuelConsumptionTable
  },
  
  data(){
      return{
          ship: store.getters.currentShip,
          fuelConsumptionArray : store.getters.currentShip.fuelConsumption,
          oldPrewrittenCIIAux : store.getters.currentShip.oldPrewrittenCII,
          vTanks : store.getters.currentShip.vTanks,

          oldPrewrittenCIIList : [],
          //estos 2 array son únicamente para mostrarlos en el frontend
          firstHalfOldCIIList : [],
          secondHalfOldCIIList: [],
          //variables sobre las preguntas de los inputs
          //iceClassTypeOptions: [],
         // iceClassTypeSelected: { id: "", name: "" },
          shipTankerTypeOptions : ["Lanzadera (Shuttle)", "STS (Ship to Ship)" , "None"],
          shipTankerTypeSelected : { name: "" },

          options: ["Yes", "No"],
          shipStructuralImprovements : "No",
          shipChemicalTanker: "No",
          shipLightTransport: "No",

          //variables numéricas para los cálculos del CII
          arrayFuelVariables : [], //este es el array principal para guardar los datos de cada combustible
          travelDistance : 0,
          fuelTypeOptions : [],
          fuelTypeSelected : { name: "None" },
          sfocValuesOptions : ["175", "200", "Personalized"],
          sfocValuesSelected : { id: "", name: "" },
          //personalizedSFOC : 0,

          //Para FCelectrical
          fcElectricalOptions: ["Contenedores refrigerados (reefer)", "Sistemas de refrigeración en buques gaseros y GNL (cooling)",
                                  "Bombas de descarga eléctricas (discharge)", "None"],
          fcElectricalArray: [],
          //fcElectricalSelected: { id: "", name: "" },
          //canMonitorElecConsumption : "Yes",

          //variables de OUTPUT de CII
          numCIIYears: 18, //hasta 2035 son 13, hasta 2040 con 18
          attainedCII : 0,
          anualPrewrittenCII : [],
          firstHalfCIIList : [],
          secondHalfCIIList: [],
          thirdHalfCIIList: [],

          //modal de resultados
          modalVisible : false,
          //colorCII : "Bcolor",
          letterCIIValues : [],
          firstLineLetterValues : [],
          secondLineLetterValues : [],
          thirdLineLetterValues : []
      }
  },

  created(){
    
    this.modalVisible = false
    this.shipService = ShipService.getInstance();
    this.carbonService = NeobuqCarbonService.getInstance();
    ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion);

    //si no existe dataForCII (primera vez que metemos estos datos), hay que inicializar las variables que cogemos
    //console.log(this.ship.dataForCII)
    if(this.ship.dataForCII != null || this.ship.dataForCII != undefined){

      //console.log("Habemus datos del CII previos")
      this.shipTankerTypeSelected.name = store.getters.currentShip.dataForCII.shipTankerType
      this.travelDistance = store.getters.currentShip.dataForCII.travelDistance
      this.arrayFuelVariables =  store.getters.currentShip.dataForCII.arrayFuelVariables
      this.anualPrewrittenCII = store.getters.currentShip.anualPrewrittenCII

      //console.log(" this.arrayFuelVariables" )
      //console.log( this.arrayFuelVariables )

      if(!this.ship.dataForCII.shipStructuralImprovements){
        this.shipStructuralImprovements = "No"
      }else{
        this.shipStructuralImprovements = "Yes"
      }

      if(!this.ship.dataForCII.shipChemicalTanker){
        this.shipChemicalTanker = "No"
      }else{
        this.shipChemicalTanker = "Yes"
      }

      if(!this.ship.dataForCII.shipLightTransport){
        this.shipLightTransport = "No"
      }else{
        this.shipLightTransport = "Yes"
      }

      //console.log("array fuel variables is null " + (store.getters.currentShip.dataForCII.arrayFuelVariables == null))
      if(store.getters.currentShip.dataForCII.arrayFuelVariables != null && store.getters.currentShip.dataForCII.arrayFuelVariables != undefined){
        this.fcElectricalArray = store.getters.currentShip.dataForCII.arrayFuelVariables
      }

      this.fuelTypeSelected.name
      //console.log("this.fuelTypeSelected.name")
      //console.log(this.fuelTypeSelected.name)

      /*for(let f=0; f < this.arrayFuelVariables.length; f++){
        console.log("this.arrayFuelVariables[ " + f + "].fuel.fuel.name")
        console.log(this.arrayFuelVariables[f].fuel.fuel.name)
      }*/
    }else{
      //console.log("NO TENEMOS datos del CII previos")
      for(let i=0; i< this.fuelConsumptionArray.length; i++){
        //sólo vamos a realizar el CII con los combustibles antiguos
        if(this.fuelConsumptionArray[i].fuel.for_cii){
          var itemAux = {fuel : this.fuelConsumptionArray[i], 
            FCvoyage : 0, 
            FCboiler: 0, 
            FCothers: 0, 
            FCelectrical : 0,
            typeFCelec: { id: "", name: "None" },
            canMonitorElecConsumption : "",
            selectedSFOC: { id: "", name: "" },
            personalizedSFOC : 0,
            SFOC : 0,
            FCs: 0,
            reefer : 0,
            daysSea: 0,
            daysPort: 0,
            numContainers: 0,
            nocArrival: 0,
            nocDeparture: 0,
            cooling: 0,
            discharge: 0}
          this.arrayFuelVariables.push(itemAux)
        }
      }

      //creamos el array del CII anual preescrito
      var numYear = 23
      for(let j=0; j< this.numCIIYears; j++ ){

        var strYear = "20" + numYear
        var item = {year : strYear, value: 0}
        this.anualPrewrittenCII.push(item)
        numYear++;
      }

      //console.log(this.anualPrewrittenCII)
    }
    
    //mapeamos el array obtenido de la base de datos en un array local para usarlo
    this.oldPrewrittenCIIList = Object.keys(this.oldPrewrittenCIIAux).map(year => ({
      year: year,
      value: this.oldPrewrittenCIIAux[year]
    }));

    const puntoMedio = Math.ceil(this.oldPrewrittenCIIList.length / 2);
    this.firstHalfOldCIIList = this.oldPrewrittenCIIList.slice(0, puntoMedio);
    this.secondHalfOldCIIList = this.oldPrewrittenCIIList.slice(puntoMedio);


    //creamos el array para las opciones de los combustibles para los inputs
    for(let k=0; k< this.arrayFuelVariables.length; k++){
      this.fuelTypeOptions.push(this.arrayFuelVariables[k].fuel.fuel.name)
    }
    

    this.firstHalfCIIList = this.anualPrewrittenCII.slice(0, 5);
    this.secondHalfCIIList = this.anualPrewrittenCII.slice(5, 9);
    this.thirdHalfCIIList = this.anualPrewrittenCII.slice(9, 14);

    // console.log("this.transformedFCElectricalOptions")
    // console.log(this.transformedFCElectricalOptions)
    // console.log("this.transformedFuelOptions")
    // console.log(this.transformedFuelOptions)

    // console.log("this.shipTankerTypeSelected")
    // console.log(this.shipTankerTypeSelected)

    //console.log("FCElectrical array " + JSON.stringify(this.transformedFuelOptions[1]))
    this.fcElectricalArray.forEach((fcElectrical) => {
      if(fcElectrical.typeFCelec.name != "None"){
        //console.log("FCElectrical selected " + fcElectrical.fuel.fuel.name)
        this.fuelTypeSelected = { name: fcElectrical.fuel.fuel.name }
      }
    })
  },

  mounted(){
    //var initialFuelFC = this.ship.
  },

  computed: {
    transformedFCElectricalOptions() {
      // Transforma el array de cadenas de texto en un array de objetos con la propiedad "name"
      return this.fcElectricalOptions.map(option => ({ name: option }));
    },

    transformedShipTankerOptions(){
      return this.shipTankerTypeOptions.map(option => ({ name: option }));
    },

    transformedFuelOptions(){
      return this.fuelTypeOptions.map(option => ({ name: option }))
    },

    transformedSfocValuesOptions(){
      return this.sfocValuesOptions.map(option => ({ name: option }))
    },

    filteredFuelVariables() {
      return this.arrayFuelVariables.filter(item => item.fuel.fuel.name === this.fuelTypeSelected.name);
    },

    tankerSelectedOnLoad(){
      for(let i=0; i < this.shipTankerTypeOptions.length; i++){
        if(this.ship.dataForCII.shipTankerType == this.shipTankerTypeOptions[i].name){
          //console.log(this.shipTankerTypeOptions[i].name)
          return this.shipTankerTypeOptions[i].id
        }
      }
      return 0
    }
  },

  methods:{

    calcAnualCII(){
      //console.log("Calculamos el CII anual desde 2023-2035")
      //este cálculo es igual que el antiguo, asi que usamos la misma función

      var do_anual_cii = false

      //comprobamos los tipos de combustible del buque y vemos con cuales podemos comprobar el CII
      for(let i=0; i < this.ship.fuelConsumption.length; i++){

        //si al menos uno de los combustibles se usa para cii, hacemos el CII
        if(this.ship.fuelConsumption[i].fuel.for_cii){
          do_anual_cii = true
        }
      }

      if(do_anual_cii){
        //console.log("Hacemos el CII preescrito!")
        //lo calculamos para cada año
        const list_prewritten_CIIs = this.carbonService.calc_anual_prewritten_CII(this.ship)
        //console.log(list_prewritten_CIIs)
        //console.log(this.anualPrewrittenCII)

        for(let i=0; i<this.anualPrewrittenCII.length; i++){
          this.anualPrewrittenCII[i].value = list_prewritten_CIIs[i].toFixed(2)
        }
      }
    },

    calcAttainedCII(){
      //console.log("Calculamos el CII obtenido para todos los años...")

      //asignamos el tipo de clase hielo al buque
      //this.ship.iceClassType = this.iceClassTypeSelected

      //ponemos el SFOC correcto
      for(let i=0; i< this.arrayFuelVariables.length; i++){
        if(this.arrayFuelVariables[i].selectedSFOC.name=="Personalized"){
          this.arrayFuelVariables[i].SFOC = parseFloat(this.arrayFuelVariables[i].personalizedSFOC)
        }else if(this.arrayFuelVariables[i].selectedSFOC.name=="200" || this.arrayFuelVariables[i].selectedSFOC.name=="175"){
          this.arrayFuelVariables[i].SFOC = parseFloat(this.arrayFuelVariables[i].selectedSFOC.name)
        }
      }

      //guardamos los datos que vamos a necesitar, que no están incluidos en el modelo 'ship'
      const shipCIIData = {
        shipStructuralImprovements : this.shipStructuralImprovements === "Yes" ? true : false,
        shipChemicalTanker : this.shipChemicalTanker === "Yes" ? true : false,
        shipLightTransport : this.shipLightTransport === "Yes" ? true : false,
        shipTankerType : this.shipTankerTypeSelected.name ? this.shipTankerTypeSelected.name : null,

        arrayFuelVariables : this.arrayFuelVariables,
        travelDistance : this.travelDistance,

        numFuels : this.arrayFuelVariables.length
      }

      //esto nos va a devolver una lista con todos los CII obtenidos de todos los años (desde 2023-2040)
      this.ship.anualPrewrittenCII = this.anualPrewrittenCII
      this.ship.baseCII = this.carbonService.calc_attained_CII(this.ship, shipCIIData, this.anualPrewrittenCII)

      /*this.anualFuelEUVariables[i] = this.fuelEUService.calc_fuelEU_values(itemSelected, this.ship, this.selectedGWPOPtion)

          var aux = {year: this.anualFuelEUVariables[i].year, value: this.anualFuelEUVariables[i].fuelEUPenalty}
          this.ship.baseFuelEU.push(aux) */

      //ya está guardado en this.ship, ahora vamos a mostrarlo en el modal
      this.showResults()      
    },

    showResults(){

      this.modalVisible = true
      //les asignamos los colores correspondientes 
      //console.log(this.ship.baseCII)
      for(let i=0; i< this.ship.baseCII.length; i++){
        switch(this.ship.baseCII[i].letter){
          case "A":
            this.ship.baseCII[i].color = "Acolor"
            break;
          case "B":
            this.ship.baseCII[i].color = "Bcolor"
            break;
          case "C":
            this.ship.baseCII[i].color = "Ccolor"
            break;
          case "D":
            this.ship.baseCII[i].color = "Dcolor"
            break;
          case "E":
            this.ship.baseCII[i].color= "Ecolor"
            break;
        }
      }

      //los dividimos en 3 filas para ponerlo cómodo en el modal
      this.firstLineLetterValues = this.ship.baseCII.slice(0,6)
      this.secondLineLetterValues = this.ship.baseCII.slice(6,12)
      this.thirdLineLetterValues = this.ship.baseCII.slice(12,18)
    },

    save(){
      //console.log("Guardamos el CII de este barco...")

      //REVISAR QUE SE INTRODUCEN CORRECTAMENTE LOS CAMPOS
      
      const errorsInSave = this.shipService.saveShip(store.getters.currentShip);

      if (errorsInSave === "") {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: "Datos guardados correctamente",
          life: 1000,
        });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error guardando los datos:" + errorsInSave,
          life: 5000,
        });
      }
    },

    cancel(){
      //console.log("NeobuqCarbonForm-cancel", this.ship);
      this.shipService.selectedShip({});
      router.push({ name: "neobuqHome" });
    }
  }

}

</script>

<style scoped>

.button{
  height: 70px;
  border-radius: 20px;
  text-align: center;
}

.letter-cii-value{
  border-style: solid;
  border-width: 1px;
  border-color: black;
  height: 50px;
  width: 100px;
  text-align: center;
  padding-top: 5px;
  font-weight: 700;
}

#Acolor {
  font-weight: 700;
  background-color: #66bb6a;
}
#Bcolor {
  font-weight: 700;
  background-color: #d7e3bc;
}
#Ccolor {
  font-weight: 700;
  background-color: #f6f474;
}
#Dcolor {
  font-weight: 700;
  background-color: #fbd5b5;
}
#Ecolor {
  font-weight: 700;
  background-color: #e36c09;
}

#attainedCII{
  border-style: solid;
  border-color: black;
  border-width: 1px;
  height: 30px;
  width: 200px;
  padding-top: 4px;
}

#oldCIIBox{
  border-color: black;
  border-style: solid;
}

.oldPrewittenCIILabel{
  text-align: left; 
  padding-left: 8px; 
  padding-top: 8px;
}

.CII_value{
  display : inline; 
  border-style: solid;
  border-width: 1px;
}

.input-box{
  border-style: dotted;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 450px;
}

.input-box-two{
  border-style: dotted;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 450px;
}

.input-fuel-box{
  display: flex;
  border-style: solid;
  padding: 8px;
  width: 130%;
}

.output-box{
  width: 100%;
  border-style: solid;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}

.display-flex{
  display: flex;
}

.input-style{
    border-radius: 5px;
    height: 40px;
    width: 150px;
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}

/* Estilo de las tablas */
.styled-table th,
.styled-table td {
  padding: 16px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.styled-table th {
  background-color: #f2f2f2;
}

.styled-table tbody tr:last-child td {
  border-bottom: none;
}

.styled-table tbody tr:hover {
  background-color: #f5f5f5;
}

</style>